import React, { useEffect } from "react";
// import CloseIcon from "@mui/icons-material/Close";

export default function InlineErrorAlert({
    message,
    onClose,
    severity,
    autoClose = true,
}) {
    useEffect(() => {
        if (!onClose || !autoClose) return undefined;

        const timeoutId = setTimeout(() => {
            onClose();
        }, 7000);

        return () => clearTimeout(timeoutId);
    }, [autoClose, onClose, message, severity]);

    return (
        <div
            style={{
                position: "absolute",
                top: 20,
                zIndex: 1300,
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "10px 16px",
                borderRadius: "8px",
                backgroundColor: "#FFFFFF",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.08)",
                border: "1px solid #F2F2F2",
                maxWidth: "480px",
            }}
        >
            {severity === "error" && (
                <div
                    style={{
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        backgroundColor: "#F44336",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                    }}
                >
                    <span
                        style={{
                            color: "#FFFFFF",
                            fontSize: 14,
                            fontWeight: 700,
                            lineHeight: 1,
                        }}
                    >
                        ×
                    </span>
                </div>
            )}

            {severity === "success" && (
                <div
                    style={{
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        backgroundColor: "#0F9BB0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                    }}
                >
                    <span
                        style={{
                            color: "#FFFFFF",
                            fontSize: 16,
                            fontWeight: 700,
                            lineHeight: 1,
                        }}
                    >
                        ✓
                    </span>
                </div>
            )}
            <span
                style={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    color: "#333333",
                    flex: 1,
                }}
            >
                {message}
            </span>
            {/* {onClose && (
                <button
                    type="button"
                    onClick={onClose}
                    style={{
                        border: "none",
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#999999",
                    }}
                >
                    <CloseIcon fontSize="small" />
                </button>
            )} */}
        </div>
    );
}
